import * as SDK from '@vkontakte/calls-sdk'

export const getCallUser = (id) => {

    const user : SDK.ExternalId = {
        id : id,
        type : SDK.ExternalIdType.USER
    }
    return user
}
